import React, { useState } from "react";
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, Text, Spinner } from "@chakra-ui/react";

const ShareTicketModal = ({ isOpen, onClose, onConfirm }) => {
    const [isLoading, setIsLoading] = useState(false); 

    const handleConfirm = async () => {
        setIsLoading(true);
        await onConfirm(); 
        setIsLoading(false);
    };

    return (
        <Modal isOpen={isOpen} onClose={isLoading ? null : onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Podijelite zadatak</ModalHeader>
                <ModalBody>
                    <Text>Želite li podijeliti zadatak?</Text>
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme="gray" onClick={onClose} isDisabled={isLoading}>Povratak</Button>
                    <Button colorScheme="blue" ml={3} onClick={handleConfirm} isLoading={isLoading} loadingText="Sharing">
                        Podijeli
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ShareTicketModal;
